// biome-ignore lint/correctness/noUnusedImports: existing error
import React from 'react';
import {Button} from '~library/atoms/Button';
import {FiltersIcon} from '~library/svg/FiltersIcon';

export const FilterButton = (props) => (
  <Button
    onClick={props.onClick}
    variant="secondary"
    size="small"
    data-qa-id="button-open-filters"
    className="gallery__open-filters-button"
  >
    <FiltersIcon /> Filters
  </Button>
);
